// src/components/ui/Modal.jsx

import React from "react";
import ReactDOM from "react-dom";
import clsx from "clsx";

/**
 * Modal component renders a centered overlay.
 * @param {boolean} isOpen - Modal visibility
 * @param {function} onClose - Close callback
 * @param {React.ReactNode} children - Modal content
 * @param {string} size - sm, md, lg, xl
 */
const Modal = ({ isOpen, onClose, children, size = "md" }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: "w-11/12 max-w-sm sm:max-w-xs",
    md: "w-11/12 max-w-md sm:max-w-sm md:max-w-md",
    lg: "w-11/12 max-w-lg sm:max-w-md md:max-w-lg",
    xl: "w-11/12 max-w-xl sm:max-w-lg md:max-w-xl",
  };

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className={clsx(
          "bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-8 lg:p-10 xl:p-12",
          sizeClasses[size]
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default Modal;